export const PROPERTIES_SORT_COLUMN_DEFAULT = "created_at"
export const PROPERTIES_SORT_ORDER_DEFAULT = "desc"

export const PropertyTypes = {
  OFFICE: "office",
  OTHER: "other",
  LAND: "land",
  APARTMENT: "apartment",
  WAREHOUSE: "warehouse",
  HOUSE: "house",
  BUSINESS: "business",
  GARAGE_PARKING: "garage_parking",
  BUILDING: "building",
  BOAT: "boat",
  CELLAR_BOX: "cellar_box",
} as const
export type PropertyTypes = (typeof PropertyTypes)[keyof typeof PropertyTypes]

export const PROPERTY_PREVIEW_WIDTH = 600
export const PROPERTY_SMALL_PREVIEW_WIDTH = 250

export const PropertyAreaType = {
  LAND: "land",
} as const
export type PropertyAreaType = (typeof PropertyAreaType)[keyof typeof PropertyAreaType]

/*
export const PropertyStatus = {
  ACTIVE: "active",
  ARCHIVE: "archive",
} as const
export type PropertyStatus = typeof PropertyStatus[keyof typeof PropertyStatus]
*/
